import Wall from "@/models/Wall";
import Form from "@/models/Form";
import RaumRechteck from '@/assets/images/Raum/Rechteck.png'
import RaumLForm from '@/assets/images/Raum/L-Form.png'
import RaumTForm from '@/assets/images/Raum/T-Form.png'
import RaumUForm from '@/assets/images/Raum/U-Form.png'

function formteileCalculatorFor({ innenecken = [], außenecken = [] }) {
    return (walls) => {
        const findWall = name => walls.find(wall => name == wall.name)
        const areRequiredWallsActive = required_wall_names => !required_wall_names.split('').some(required_wall_name => findWall(required_wall_name) == undefined)
        const getFormteileFor = specifications => specifications.map(required_wall_names => areRequiredWallsActive(required_wall_names) ? 1 : 0).reduce((sum, current) => sum + current, 0)
        return {
            innenecken: getFormteileFor(innenecken),
            außenecken: getFormteileFor(außenecken),
        }
    }
}

export default () => ({
    [Form.ROOM_SHAPE.RECTANGLE]: {
        image: RaumRechteck,
        walls: [
            Wall.make({ name: 'A' }),
            Wall.make({ name: 'B' }),
            Wall.make({ name: 'C' }),
            Wall.make({ name: 'D' }),
        ],
        formteile: formteileCalculatorFor({
            innenecken: ['AB', 'BC', 'CD', 'DA']
        })
    },
    [Form.ROOM_SHAPE.T]: {
        image: RaumTForm,
        walls: [
            Wall.make({ name: 'A' }),
            Wall.make({ name: 'B' }),
            Wall.make({ name: 'C' }),
            Wall.make({ name: 'D' }),
            Wall.make({ name: 'E' }),
            Wall.make({ name: 'F' }),
            Wall.make({ name: 'G' }),
            Wall.make({ name: 'H' }),
        ],
        formteile: formteileCalculatorFor({
            innenecken: ['AB', 'BC', 'DE', 'EF', 'GH', 'HA'],
            außenecken: ['GF', 'CD']
        })
    },
    [Form.ROOM_SHAPE.L]: {
        image: RaumLForm,
        walls: [
            Wall.make({ name: 'A' }),
            Wall.make({ name: 'B' }),
            Wall.make({ name: 'C' }),
            Wall.make({ name: 'D' }),
            Wall.make({ name: 'E' }),
            Wall.make({ name: 'F' }),
        ],
        formteile: formteileCalculatorFor({
            innenecken: ['AB', 'BC', 'DE', 'EF', 'FA'],
            außenecken: ['CD']
        })
    },
    [Form.ROOM_SHAPE.U]: {
        image: RaumUForm,
        walls: [
            Wall.make({ name: 'A' }),
            Wall.make({ name: 'B' }),
            Wall.make({ name: 'C' }),
            Wall.make({ name: 'D' }),
            Wall.make({ name: 'E' }),
            Wall.make({ name: 'F' }),
            Wall.make({ name: 'G' }),
            Wall.make({ name: 'H' }),
        ],
        formteile: formteileCalculatorFor({
            innenecken: ['AB', 'BC', 'EF', 'FG', 'GH', 'HA'],
            außenecken: ['CD', 'DE']
        })
    },
    // [Form.ROOM_SHAPE.INDIVIDUAL]: {
    //     walls: [],
    //     formteile: () => ({
    //         innenecken: 'individuell',
    //         außenecken: 'individuell',
    //     })
    // },
})